import { Button, Box } from '@mui/material';

/** This component is displayed as the sub buttons at the lower level of Scope 3 after the user expands the Scope 3 dashboard accordion.
 * @param {Object} props Sub categories to loop over. Selected category to compare against. Setter function to set category when the user clicks it.
 * @param {Array} props.subCategories Sub categories array.
 * @param {string} props.selectedCategory The currently selected sub category.
 * @param {(selectedCategory: string) => void} props.setSelectedCategory A setter function given by useState that will update the selected category on click.
 * @returns {JSX.Element}
 */

export default function SubCategoryButtons({ subCategories, selectedSubCategory, setSelectedSubCategory }) {

    return (
        <Box my={2} sx={{ display: 'flex', justifyContent: 'flex-start', flexWrap: 'wrap', gap: 4 }}>
            {subCategories.map((subCategory, index) => {
                return (
                    <Button
                        key={index}
                        sx={{ width: 'fit-content' }}
                        variant={subCategory === selectedSubCategory ? 'contained' : 'outlined'}
                        size='large'
                        onClick={() => {
                            setSelectedSubCategory(subCategory);
                        }}
                    >
                        {subCategory}
                    </Button>
                )
            })
            }
        </Box>
    )
}